import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import classNames from 'classnames'
import Button from '@material-ui/core/Button'

const useStyles = makeStyles(theme => ({
    btnCommon: {
        height: 45,
        textTransform: 'none',
        fontSize: 12,
        fontWeight: 'bold',
        borderRadius: 7,
        paddingLeft: 35,
        paddingRight: 35,
        display: 'flex',
        alignItems: 'center'
        // padding: '13px 35px'
    },
    btn: {
        background: theme.primary,
        color: theme.textPrimaryReverted,
        fontFamily: theme.fontFamily,
        '&:hover': {
            background: theme.primaryHover
        }
    },
    btnCTA: {
        background: theme.cta,
        color: theme.textPrimary,
        fontFamily: theme.fontFamily,
        fontSize: 13,
        '&:hover': {
            background: theme.cta,
            opacity: 0.7
        }
    },
    btnWarning: {
        background: theme.warning,
        color: theme.textPrimaryReverted,
        fontFamily: theme.fontFamily,
        '&:hover': {
            background: theme.warning,
            opacity: 0.7
        }
    },
    btnError: {
        background: theme.error,
        color: theme.textPrimaryReverted,
        fontFamily: theme.fontFamily,
        '&:hover': {
            background: theme.error,
            opacity: 0.7
        }
    },
    btnActive: {
        background: theme.active,
        color: theme.textPrimaryReverted,
        fontFamily: theme.fontFamily,
        '&:hover': {
            background: theme.active,
            opacity: 0.7
        }
    },
    btnReverted: {
        /* background: theme.mainBackground, */
        background: 'none',
        border: theme.border,
        color: theme.primary,
        '&:hover': {
            // background: 'none',
            background: theme.revertedHover /* ,
            textDecoration: 'underline' */
        }
    },
    disabled: {
        color: `${theme.textSecondary} !important`,
        background: theme.secondary
    },
    sign: {
        marginRight: 10
    }
}))

export default function CustomButton(props) {
    const classes = useStyles()

    const {
        children,
        onClick,
        reverted,
        sign,
        warning,
        error,
        active,
        cta,
        ...restProps
    } = props
    const restClasses = { ...restProps }.className

    return (
        <Button
            {...restProps}
            className={classNames({
                [`${classes.btnCommon}`]: true,
                [`${classes.btn}`]:
                    !reverted && !warning && !error && !active && !cta,
                [`${classes.btnWarning}`]: warning,
                [`${classes.btnActive}`]: active,
                [`${classes.btnError}`]: error,
                [`${classes.btnReverted}`]: reverted,
                [`${classes.btnCTA}`]: cta,
                [`${restClasses}`]: restClasses
            })}
            onClick={onClick}
            classes={{
                disabled: classes.disabled
            }}>
            {sign && <span className={classes.sign}>{sign}</span>}
            {children}
        </Button>
    )
}
